import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

import SectionCard from "../SectionCard";
import LabelBadge from "./components/LabelBadge";

import "./index.scss";

const chunkImages = (items = [], size = 2) => {
  const rows = [];

  for (let i = 0; i < items.length; i += size) {
    rows.push(items.slice(i, i + size));
  }

  return rows;
};

const renderRow = (row, rowIndex) => (
  <div className="image-grid-row" key={`row-${rowIndex}`}>
    {row.map((img, colIndex) => {
      const index = rowIndex * 2 + colIndex;

      return (
        <div className="image-card" key={index}>
          <div className="image-inner">
            <div className="image-wrapper">
              <img src={img.url} alt={`img-${index}`} />

              {img.label && (
                <div className="badge-overlay">
                  <LabelBadge label={img.label} />
                </div>
              )}
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

const LabelImages = ({ images = [], t }) => {
  const imageRows = chunkImages(images, 2);
  const firstRow = imageRows[0];
  const remainingRows = imageRows.slice(1);

  return (
    <SectionCard onContentBorder>
      <div className="attachments-section">
        {firstRow?.length ? (
          <>
            <div className="attachments-first-block">
              <div className="attachments-section-header">
                <span className="attachments-section-header-icon">
                  <FontAwesomeIcon icon={faPaperclip} />
                </span>
                <span className="attachments-section-header-text">{t("cc_attachments").message || "Attachments"}</span>
              </div>

              {renderRow(firstRow, 0)}
            </div>

            {remainingRows.map((row, index) => renderRow(row, index + 1))}
          </>
        ) : (
          <div className="attachments-section-header">
            <span className="attachments-section-header-icon">
              <FontAwesomeIcon icon={faPaperclip} />
            </span>
            <span className="attachments-section-header-text">{t("cc_attachments").message || "Attachments"}</span>
          </div>
        )}
      </div>
    </SectionCard>
  );
};

export default withTranslation()(LabelImages);
